import { EXPENSE_TYPE_ORDER } from "web_myplann/Finances/constants";
import type { ClientFinancialPlanExpenseTypeEnum } from "web_myplann/Infrastructure/Api/Api";

export type IndexedExpense<TExpense> = {
	index: number;
	expense: TExpense;
};

type ExpenseGroups<TExpense> = Record<
	ClientFinancialPlanExpenseTypeEnum,
	IndexedExpense<TExpense>[]
>;

export const groupExpensesByType = <
	TExpense extends { type: ClientFinancialPlanExpenseTypeEnum },
>(
	expenses: TExpense[],
): ExpenseGroups<TExpense> => {
	const groups = {} as ExpenseGroups<TExpense>;
	for (const type of EXPENSE_TYPE_ORDER) {
		groups[type] = [];
	}

	expenses.forEach((expense, index) => {
		if (!groups[expense.type]) {
			groups[expense.type] = [];
		}
		groups[expense.type].push({ index, expense });
	});

	return groups;
};
